import { FormEvent, useRef } from 'react'
import html2canvas from 'html2canvas'

import * as S from './styles'
import Corretor from '../Corretor'
import Mensagem from '../Mensagem'
import Conta from '../Conta'
import Zoom from '../Zoom'

import imgCorretora from '../../assets/images/imgCorretora.png'
import imgCorretor from '../../assets/images/imgCorretor.png'
import imgImovelCard from '../../assets/images/imgImovelCard.png'
import Modal from '../Modal'
import Button from '../Button'

type Props = {
  type: 'info' | 'mensage' | 'conta' | 'modal' | 'dowloadImage' | 'zoom'
}

const Card = ({ type }: Props) => {
  const elementoRef = useRef(null)

  const capturar = (e: FormEvent) => {
    e.preventDefault()
    if (elementoRef.current) {
      html2canvas(elementoRef.current).then((canvas) => {
        const imagemUrl = canvas.toDataURL()
        const link = document.createElement('a')
        link.href = imagemUrl
        link.download = 'imovelguide.png'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      })
    }
  }

  if (type === 'info') {
    return (
      <S.Card>
        <Corretor
          imgCorretor={imgCorretora}
          nome="Nome da Corretora"
          pontos={3000}
          telefone="(99) 99999-9999"
        />
        <Corretor
          imgCorretor={imgCorretor}
          nome="Nome do Corretor"
          pontos={1260}
          telefone="(99) 99999-9999"
        />
      </S.Card>
    )
  }

  if (type === 'mensage') {
    return (
      <S.Card>
        <h2>Mande uma Mensagem:</h2>
        <Mensagem />
      </S.Card>
    )
  }

  if (type === 'conta') {
    return (
      <S.Card>
        <h2>Regra de 3</h2>
        <Conta />
      </S.Card>
    )
  }

  if (type === 'modal') {
    return (
      <S.Section>
        <S.Card style={{ backgroundImage: `url(${imgImovelCard})` }} />
        <Modal />
      </S.Section>
    )
  }

  if (type === 'dowloadImage') {
    return (
      <S.Section>
        <S.Card
          ref={elementoRef}
          className="download"
          style={{ backgroundImage: `url(${imgImovelCard})` }}
        >
          <p>Imovel Guide</p>
        </S.Card>
        <form onSubmit={capturar}>
          <Button>Download</Button>
        </form>
      </S.Section>
    )
  }

  if (type === 'zoom') {
    return (
      <S.Card>
        <Zoom />
      </S.Card>
    )
  }

  return <h4>Carregan...</h4>
}

export default Card
